import { EventStreamPanel } from "../../../components/admin/event-hub/EventStreamPanel";

export function AdminEventStreamPage() {
  return <EventStreamPanel />;
}
